import { useQuery } from '@tanstack/react-query';

import { FIVE_MINUTES } from '../../../helpers/timeConstants';
import { getLookerDashboardsService } from '../OrderReport.services';
import { LookerDashboard } from '../types/dashboard';

export default function useLookerDashboards(appId: string) {
  return useQuery({
    queryKey: ['lookerDashboards', appId],
    queryFn: () => getLookerDashboardsService(appId),
    enabled: !!appId,
    staleTime: FIVE_MINUTES,
    select: (data: LookerDashboard[]) =>
      data.filter(
        (dashboard: LookerDashboard) =>
          dashboard.DashboardLink &&
          dashboard.DashboardLink !== 'flipdish_phone_marketing_fpm_report'
      ),
  });
}
